import { QuestionApi } from "@sw-sw/lib-inspection-templates";
import xhrService from "../api";

export const questionApi: QuestionApi & { getIsUsedTemplate: (id: number) => Promise<boolean> } = {
  show: id => {
    return xhrService
      .get(`/api/questions/${id}`)
      .then(res => res.data)
      .catch(({ response }) => {
        throw new Error(response.data.message);
      });
  },
  create: (groupId, newQuestion) => {
    ///////////////////
    console.log(groupId);
    ///////////////////
    const payload = {
      ...newQuestion,
      input_label: Object.prototype.hasOwnProperty.call(newQuestion, 'input_label') ? newQuestion.input_label ?? '' : '',
    };

    return xhrService
      .post(`/api/questions`, payload)
      .then(res => res.data)
      .catch(({ response }) => {
        throw new Error(response.data.message);
      });
  },

  update: (id, data) => {
    const payload = {
      ...data,
      input_label: Object.prototype.hasOwnProperty.call(data, 'input_label') ? data.input_label ?? '' : '',
    };

    return xhrService
      .put(`/api/questions/${id}`, payload)
      .then(res => res.data)
      .catch(({ response }) => {
        throw new Error(response.data.message);
      });
  },

  delete: id => {
    return xhrService
      .delete(`/api/questions/${id}`)
      .then(res => res.data)
      .catch(({ response }) => {
        throw new Error(response.data.message);
      });
  },

  getIsUsedTemplate: questionId => {
    return xhrService
      .get(`/api/inspectionsQuestion/isUsed/${questionId}`)
      .then(res => res.data.isUsed)
      .catch(({ response }) => {
        throw new Error(response.data.message);
      });
  },
};
